import { render, staticRenderFns } from "./statementLog.vue?vue&type=template&id=8700f99c&scoped=true"
import script from "./statementLog.vue?vue&type=script&lang=js"
export * from "./statementLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8700f99c",
  null
  
)

export default component.exports